import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import {
    selectDocumentSet,
    selectDocumentSetId
} from 'services/documentSets/selectors';
import { selectDocumentsArray } from 'services/documents/selectors';
import { selectEvents } from 'services/events/selectors';
import { selectSchemas } from 'services/schemas/selectors';
// @ts-ignore
import { selectSchemaAttributesArray } from 'services/schemaAttributes/selectors';
import { Schema } from 'services/schemas/types';

const selectSchema = createDeepEqualSelector(
    [selectDocumentSet, selectEvents, selectSchemas],
    ({ eventId }, events, schemas): Schema | null => {
        if (!events[eventId]) return null;

        const { schemaId } = events[eventId];

        return schemas[schemaId];
    }
);

const selectSchemaAttributeIds = createDeepEqualSelector(
    [selectDocumentSet, selectSchema, selectSchemaAttributesArray],
    (documentSet, schema, schemaAttributes: any[]) => {
        const { documentSetAttributes } = documentSet;
        let schemaAttributeIds: number[] = [];

        if (!schema) return schemaAttributeIds;

        schemaAttributeIds = schemaAttributes
            .filter(({ schemaId }) => schemaId === schema.id)
            .sort((a, b) => a.orderIndex - b.orderIndex)
            .map(({ id }) => id);

        if (
            schema.hasInstructions &&
            documentSetAttributes &&
            documentSetAttributes.length
        ) {
            const filteredIds = documentSetAttributes.map(
                ({ schemaAttributeId }) => schemaAttributeId
            );

            schemaAttributeIds = schemaAttributeIds.filter((id) =>
                filteredIds.includes(id)
            );
        }

        return schemaAttributeIds;
    }
);

export const makeSelectSchemaAttributeIds =
    (): typeof selectSchemaAttributeIds => selectSchemaAttributeIds;

const selectAssessmentsCount = createDeepEqualSelector(
    [selectDocumentSetId, selectDocumentsArray],
    (documentSetId, documents) =>
        documents.filter((document) => document.documentSetId === documentSetId)
            .length
);

const selectAssessmentsExist = createDeepEqualSelector(
    [selectAssessmentsCount],
    (count) => !!count
);

export const makeSelectAssessmentsExist = (): typeof selectAssessmentsExist =>
    selectAssessmentsExist;

const selectIsMultipleAssessments = createDeepEqualSelector(
    [selectAssessmentsCount],
    (count) => count > 1
);

export const makeSelectIsMultipleAssessments =
    (): typeof selectIsMultipleAssessments => selectIsMultipleAssessments;
